import { useLocation } from "react-router-dom";
import { Check, ChevronDown, Globe2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  LANGUAGE_NAMES,
  SUPPORTED_LANGUAGES,
  getPathLanguage,
  stripLanguagePrefix,
  withLanguagePrefix,
} from "@/lib/i18n";

export default function LanguageSelector({ className = "" }) {
  const location = useLocation();
  const currentLanguage = getPathLanguage(location.pathname);

  const switchLanguage = (nextLanguage) => {
    if (nextLanguage === currentLanguage) return;

    const basePath = stripLanguagePrefix(location.pathname);
    const localizedPath = withLanguagePrefix(basePath, nextLanguage);
    window.location.assign(`${localizedPath}${location.search}${location.hash}`);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={`inline-flex h-9 items-center gap-1.5 rounded-full px-3 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-teal-600 ${className}`}
          aria-label={`Change language. Current language: ${LANGUAGE_NAMES[currentLanguage]}`}
        >
          <Globe2 className="h-4 w-4" aria-hidden="true" />
          <span>{currentLanguage.toUpperCase()}</span>
          <ChevronDown className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-40">
        {SUPPORTED_LANGUAGES.map((languageCode) => (
          <DropdownMenuItem
            key={languageCode}
            onSelect={() => switchLanguage(languageCode)}
            className="cursor-pointer justify-between"
          >
            {LANGUAGE_NAMES[languageCode]}
            {currentLanguage === languageCode && <Check className="h-4 w-4 text-teal-600" aria-hidden="true" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
